import type { Key } from 'react';

const getHighlightColumnKey = (column: { key?: Key; dataIndex?: unknown }) => {
  const key = column.key ?? column.dataIndex;
  if (typeof key === 'string' || typeof key === 'number') return String(key);
  if (
    Array.isArray(key) &&
    key.every(part => typeof part === 'string' || typeof part === 'number')
  ) {
    return key.join('.');
  }
  return undefined;
};

export default getHighlightColumnKey;
